import React from 'react';
import "../invoices.css";


class QuoteDetail extends React.Component {

  constructor() {
    super();
    this.state = {
      quotejson: global.quoteJSON,

      quoteId: global.quoteJSON.d__QuoteID,
      date: global.quoteJSON.c__QuoteDateFormatted,
      expiredDate: global.quoteJSON.c__ExpiredDateFormatted,
      description: global.quoteJSON.d__Description,
      status: global.quoteJSON.d__Status,
      netValue: global.quoteJSON.d__Value_NET
    }
  };




render() {

return (

    <div className="page-section">
    <div className="title-section">
    <h2>
    Quotes
    </h2>
    </div>
    <div className="sub-title-section">
    A list of all quotations from Bevl Limited. {this.state.date}
    </div>
    <div className="sub-title-section">
    A list of all quotations from Bevl Limited. {global.quoteJSON}
    </div>
    </div>

  );

}

}



export default QuoteDetail;
